import eapComponents from '../../../../modules/eap/js/eap-config'
import devopsComponents from '../../../../modules/pms/js/pms_config'

const routes = new Set([...eapComponents, ...devopsComponents]);
const initRouter = {
  routes
};
export default initRouter
